export default "__VITE_ASSET__yGSsjpF$__"